import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import TableHorizontal, {
  TableHorizontalHeader
} from '../components/TableHorizontal'

interface ShipOrderItemsProps {
  items: ItemData[]
}

export default class ShipOrderItems extends Component<ShipOrderItemsProps> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Item"), path: 'code' },
    { heading: i18n("Description"), path: 'description' },
    { heading: i18n("Quantity"), path: 'shipOrderItem.quantity' },
    { heading: i18n("Shipped"), path: 'shipOrderItem.shippedQuantity' },
    { heading: i18n("Remaining"), path: 'shipOrderItem.remainingQuantity' }
  ]

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Items")} />
        <TableHorizontal
          headers={this.tableHeaders}
          data={this.props.items} />
      </Card>
    )
  }
}
